import React, { useState } from 'react';
import { FiPlus, FiMinus } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const faqs = [
  {
    q: "Is this only for straight couples?",
    a: "No. While some translations reference common patterns, the framework works for any relationship where two people misunderstand each other. These principles of decoding intent and improving response scripts are universal and effective for all couples regardless of their dynamic."
  },
  {
    q: "What if my partner won't read it?",
    a: "The book works even if only you read it. Use the scripts unilaterally. Watch how your changed responses transform the conversation. Many readers report their partner asking 'what happened to you?'—opening the door to share the book later."
  },
  {
    q: "What format is it?",
    a: "PDF + EPUB (works on Kindle, iPhone, Android, computer). 150 pages. Instant download. Audio version included."
  },
  {
    q: "What if it doesn't help?",
    a: "30-day money-back guarantee. Read it. Try the translations. If your relationship doesn't improve, email me for a full refund. I'll eat the cost. You keep the book."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-20 bg-brand-black">
      <div className="container mx-auto px-6 max-w-3xl">
        <h2 className="text-3xl font-bold text-white mb-10 text-center">Questions? We've Got Answers</h2>
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="border-b border-white/10 pb-4">
              <button 
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex justify-between items-center text-left py-2 hover:text-brand-yellow transition-colors"
              >
                <span className="text-lg font-medium text-white">{faq.q}</span>
                <SafeIcon icon={openIndex === idx ? FiMinus : FiPlus} className="text-brand-yellow" />
              </button>
              {openIndex === idx && (
                <p className="text-gray-400 mt-2 leading-relaxed">
                  {faq.a}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;